var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"home-page"},[_c('header-block'),_c('discover-block'),_c('choose-block',{attrs:{"games-images":_vm.gamesIcons}}),_c('hidden-gems-block'),_c('legends-block',{attrs:{"games-images":_vm.gamesIcons}}),_c('our-mission-block'),_c('learn-block'),_c('story-block'),_c('footer-block')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }